export class Biosecurity_protocol {

	id: string;
	venue_id: string;
	protocol_text: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}